import * as i2 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import CryptoES from 'crypto-es';

class VcomplyAuthorizerModule {
}
VcomplyAuthorizerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: VcomplyAuthorizerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VcomplyAuthorizerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: VcomplyAuthorizerModule, imports: [HttpClientModule] });
VcomplyAuthorizerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: VcomplyAuthorizerModule, imports: [[
            HttpClientModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: VcomplyAuthorizerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        HttpClientModule
                    ],
                    exports: []
                }]
        }] });

class UtilityService {
    constructor() { }
    getRawToken() {
        const token = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        if (token?.token) {
            return token.token ?? '';
        }
        else {
            return '';
        }
    }
    getUserToken() {
        const token = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        if (token?.token) {
            try {
                const helper = new JwtHelperService();
                const tokenInfo = helper.decodeToken(this.getRawToken());
                return tokenInfo;
            }
            catch {
                return null;
            }
        }
        else {
            return null;
        }
    }
    sisTokenValid() {
        const helper = new JwtHelperService();
        const isExpired = helper.isTokenExpired(this.getRawToken());
        if (isExpired === false) {
            return true;
        }
        else {
            return false;
        }
    }
    getAuthSubDomain() {
        if (['dev.v-comply.com', 'test.v-comply.com', 'alpha.v-comply.com'].includes(window.location.host)) {
            return 'devapi.v-comply.com';
        }
        else if (window.location.host === 'beta.v-comply.com') {
            return 'betaapi.v-comply.com';
        }
        else if (window.location.host.startsWith('local')) {
            return 'devapi.v-comply.com';
        }
        else {
            return 'devapi.v-comply.com';
        }
    }
    encrypt(string) {
        return CryptoES.AES.encrypt(string, 'I@MTHEVC0MPLYUSER').toString();
    }
    isExpiryWithin3hrs() {
        const tokenInfo = this.getUserToken();
        if (tokenInfo && tokenInfo?.exp) {
            if (tokenInfo?.exp - new Date().getTime() / 1000 < 10764) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
}
UtilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: UtilityService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
UtilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: UtilityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: UtilityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AuthorizerService {
    constructor(utility, http) {
        this.utility = utility;
        this.http = http;
        this.setToken();
        this.listentToLocalStorageChanges();
        this.refreshCognitoToken();
    }
    listentToLocalStorageChanges() {
        window.addEventListener('storage', (e) => {
            if (e.key === 'currentUser') {
                this.setToken();
            }
        }, false);
    }
    refreshCognitoToken() {
        if (this.tokenData?.iss)
            if (this.utility.isExpiryWithin3hrs() || this.isTokenExpired()) {
                this.fetchRefreshToken().subscribe({
                    next: (res) => {
                        localStorage.setItem('currentUser', JSON.stringify({ token: res?.token }));
                    },
                    error: (error) => {
                        if (error?.error?.code === 'EXPIRED_TOKEN') {
                            localStorage.removeItem('currentUser');
                            console.log("Authorization expired, Logging Out");
                            this.logout();
                        }
                    }
                });
            }
    }
    setToken() {
        this.tokenData = this.utility.getUserToken() ?? null;
    }
    /**
     * Returns user details of the currently logged in user
     * @returns [Object]
     */
    getUser() {
        if (this.tokenData) {
            if (this.tokenData?.iss) {
                if (this.tokenData.user) {
                    try {
                        return JSON.parse(this.tokenData?.user);
                    }
                    catch {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
            else {
                return this.tokenData?.user ?? null;
            }
        }
        else {
            return null;
        }
    }
    /**
     * Returns the member_id of the currently logged in User
     * @returns [member_id in mongoDB _id format]
     */
    getMemberId() {
        if (this.tokenData) {
            return this.tokenData?._id ?? null;
        }
        else {
            return null;
        }
    }
    /**
     * returns the organization id of the currently logged in user
     * @returns [organization_id]
     */
    getOrganizationId() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.organisation_id) {
            return userInfo?.organisation_id ?? null;
        }
        else {
            return null;
        }
    }
    /**
     * returns  id of the currently logged in user
     * @returns [id]
     */
    getUserId() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.id) {
            return userInfo?.id ?? null;
        }
        else {
            return null;
        }
    }
    /**
     * returns  id of the currently logged in user
     * @returns [id]
     */
    getUserTimezone() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.id) {
            return userInfo?.timezone ?? null;
        }
        else {
            return null;
        }
    }
    /**
     * returns  shortname of the currently logged in user
     * @returns [short_name]
     */
    getUserShortName() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.short_name) {
            return userInfo?.short_name ?? '';
        }
        else {
            return null;
        }
    }
    /**
     * returns key admin's id of the currently logged in user's organization
     * @returns [keyAdminId]
     */
    getOrgKeyAdminId() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.keyAdminId) {
            return userInfo?.keyAdminId ?? null;
        }
        else {
            return null;
        }
    }
    /**
     * returns true if currently loggedIn user is manager
     * @returns [manager]  true/false
     */
    isManager() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.manager) {
            return userInfo?.manager ?? false;
        }
        else {
            return false;
        }
    }
    /**
   * returns true if currently loggedIn user is manager
   * @returns [admin]  true/false
   */
    isAdmin() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.admin) {
            return userInfo?.admin ?? false;
        }
        else {
            return false;
        }
    }
    /**
   * returns true if currently loggedIn user is manager
   * @returns [manager]  true/false
   */
    isKeyAdmin() {
        const userInfo = this.getUser();
        if (userInfo && userInfo?.keyAdmin) {
            return userInfo?.keyAdmin ?? false;
        }
        else {
            return false;
        }
    }
    /**
     * returns weather the token is expired
     * @returns  expired = true /not expired = false
     */
    isTokenExpired() {
        const status = this.utility.sisTokenValid();
        if (status && status === true) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * returns weather the token is expired
     * @returns  expired = false /not expired = true
     */
    isValidToken() {
        return this.isTokenValid();
    }
    getToken() {
        return this.utility.getRawToken();
    }
    logout(afterLogoutAction = 'REDIRECT') {
        const primaryToken = localStorage.getItem('primaryuser');
        if (primaryToken != null) {
            localStorage.setItem('currentUser', primaryToken);
            localStorage.removeItem('primaryuser');
            if (afterLogoutAction === 'RELOAD') {
                location.reload();
            }
            else {
                window.location.href = `https://${window.location.hostname}`;
            }
        }
        else {
            localStorage.removeItem('currentUser');
            window.location.href = `https://${window.location.hostname}`;
        }
    }
    removeTokenFromLocal() {
        localStorage.removeItem('currentUser');
    }
    isTokenValid() {
        const helper = new JwtHelperService();
        const isExpired = helper.isTokenExpired(this.utility.getRawToken());
        if (isExpired === false) {
            return true;
        }
        else {
            return false;
        }
    }
    fetchRefreshToken() {
        return this.http.post('https://' + this.utility.getAuthSubDomain() + '/VcomplyAuth/?mode=getNewIdToken', { token: this.utility.encrypt(this.utility.getRawToken()) });
    }
}
AuthorizerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AuthorizerService, deps: [{ token: UtilityService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AuthorizerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AuthorizerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.1", ngImport: i0, type: AuthorizerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UtilityService }, { type: i2.HttpClient }]; } });

/*
 * Public API Surface of vcomply-authorizer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthorizerService, VcomplyAuthorizerModule };
